import { BaseSerializer } from "./baseSerializer.ts";
import { Schedule } from "@models/Schedule.model.ts";
import { ScheduleEntrySerializer } from "./scheduleEntrySerializer.ts";

export class ScheduleSerializer extends BaseSerializer {
  public deserialize(data: any): Schedule {
    const gp = new Schedule();
    this._copyAttributes(gp, data);
    if (data.entries) {
      gp.entries = new ScheduleEntrySerializer().deserializeList(data.entries);
    }
    return gp;
  }
}
